// src/pages/e3/portfolios/table.tsx

import { Table } from "../../../features/Table";
import { type E3Portfolio, porfolios_columns } from "./columns";
import { type FilterE3PortfoliosSchema, FilterE3Portfolios } from "./filter";

const client = "e3";
const table_name = "e3_portfolios";

export const E3PortfoliosTable = () => {
  const columnVisibilityInit = {
    short_account_name: false,
    insurance_company: false,
    contract_owner: false,
    display_performance_report: false,
    bank_connection: false,
  };

  return (
    <Table<E3Portfolio, FilterE3PortfoliosSchema>
      label="Portfolios"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      columnVisibilityInit={columnVisibilityInit}
      filter={<FilterE3Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
